import { useEffect, useState } from "react";

import EventColl from "../../firebase/EventsColl";
import MessagesUserColl from "../../firebase/MessagesUserColl";
import UtilDate from "../../util/UtilDate";
import { ORG_NAME, MAPBOX_ACCESS_TOKEN } from "../../util/CommonConstants";
import "../../static/css/AdminScreen.css";

const MapImage = ({ event }) => {
  const imageUrl = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-s+000(${event.geolocation.long},${event.geolocation.lat})/${event.geolocation.long},${event.geolocation.lat},9,0,0/100x100?access_token=${MAPBOX_ACCESS_TOKEN}`;

  return (
    <img
      src={imageUrl}
      alt="Event Location"
      style={{
        width: 100,
        height: 100,
        margin: 10
      }}
    />
  );
};

const AddToGoogleCalendar = ({
  title,
  startDate,
  endDate,
  details,
  location
}) => {
  const handleAddEvent = () => {
    const event = {
      title,
      startDate: UtilDate.formatDateToGoogleCalendar(startDate), // YYYYMMDDTHHmmssZ (UTC format)
      endDate: UtilDate.formatDateToGoogleCalendar(endDate),
      details,
      location
    };

    const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      event.title
    )}&dates=${event.startDate}/${event.endDate}&details=${encodeURIComponent(
      event.details
    )}&location=${encodeURIComponent(event.location)}&sf=true&output=xml`;

    window.open(googleCalendarUrl, "_blank");
  };

  return <button onClick={handleAddEvent}>Add to Google Calendar</button>;
};

export const AdminApproveEventsScreen = () => {
  const organization = localStorage.getItem(ORG_NAME);
  const [unapprovedEvents, setUnapprovedEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    let events = await EventColl.shared.getUnapprovedEvents();
    setUnapprovedEvents(events);
  };

  const approveEvent = async (event) => {
    setIsLoading(true);

    //notify user their event has been approved
    let messageBody = "Your event has been approved!";
    messageBody += "\n\nEvent: " + event.title;
    messageBody +=
      "\nEvent Date: " + UtilDate.getDateShortWithDay(event.start_date);

    if (event.organizer_id) {
      await MessagesUserColl.shared.createIndividualMessage(
        {
          message: messageBody,
          subject: "Event Approved!"
        },
        event.organizer_id
      );
    }

    await EventColl.shared.createEvent(event, true);
    await EventColl.shared.deleteUnapprovedEvent(event.id);
    await fetchData();
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <h1>{organization} Event Approvals</h1>
      <div className="approval-container">
        {unapprovedEvents.length > 0 ? (
          unapprovedEvents.map((event) => {
            return (
              <div className="approval-card">
                <h2>{event.title}</h2>
                <MapImage event={event} />
                <h3>{event.date}</h3>
                <p>{event.description}</p>
                <AddToGoogleCalendar
                  title={event.title}
                  startDate={event.local_start_date}
                  endDate={event.local_end_date}
                  details={event.description}
                  location={
                    event.geolocation.lat + ", " + event.geolocation.long
                  }
                ></AddToGoogleCalendar>
                <button
                  disabled={isLoading}
                  onClick={() => approveEvent(event)}
                >
                  Complete Event Approval
                </button>
              </div>
            );
          })
        ) : (
          <div>
            <p>No events to approve</p>
            <a href="/admin">
              <button>Back</button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
